// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-384b3047] .viewer-class>.modal-dialog{max-width:-webkit-fit-content;max-width:-moz-fit-content;max-width:fit-content}[data-v-384b3047] .viewer-class>.modal-dialog>.modal-content{visibility:hidden}[data-v-384b3047] .shown-image{visibility:visible;margin:auto;display:block;width:100%;max-width:700px}[data-v-384b3047] .close{visibility:visible;position:absolute!important;top:25px;right:0;color:#f1f1f1!important;padding:0!important}", ""]);
// Exports
module.exports = exports;
